<template>
  <div class="bg-nosotros-trabaja">
    <el-row>
      <el-col :md="24" :xs="24" data-aos="fade-right">
        <div>
          <div class="trabajo-css" v-html="$t('programa_integridad.texto')"></div>
          <br />
          <div class="trabajo-css" v-html="$t('programa_integridad.texto2')"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
export default {
  mounted() {
    AOS.init({
      duration: 1000, // velocidad de la animación (ms)
      offset: 100, // distancia antes de activar
      once: false, // si lo ponés en true solo se anima 1 vez
    })
  },
}
</script>

<style lang="scss" scoped>
.centrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cuadro {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  min-height: 200px;
  width: 220px;
  margin: 0 auto;
  float: left;
  // margin-right: 40px;
  font-weight: 300;
  padding: 30px;
  font-size: 20px;
}
.ml20 {
  margin-right: 35px;
}

.cuadro h3 {
  font-weight: 300;
  margin: 0;
  font-size: 28px;
}

.cuadro ul {
  list-style: none;
  padding: 0;
  // margin: 0;
}

.cuadro ul > li {
  font-size: 20px;
}

.bg-nosotros-descrip {
  background-color: #d35915;
  position: relative;
  z-index: 999;
  // height: 45vh;
  // padding-top: 30px;
  padding: 60px 10px;
}

// @media screen and (min-width: 1600px) {
//   .bg-nosotros-descrip {
//     // min-height: 1350px;
//     min-height: 300px;
//   }
// }
// @media screen and (max-width: 1400px) {
//   .bg-nosotros-descrip {
//     // min-height: 1350px;
//     height: 35vh !important;
//     // min-height: 350px;
//   }
// }
// @media screen and (max-width: 375px) {
//   .bg-nosotros-descrip {
//     // min-height: 1350px;
//     height: 40vh;
//     // min-height: 600px;
//   }
// }
.titulo {
  margin: 0 auto;
  text-align: center;
  position: relative;
  padding-top: 150px;
  font-size: 2.5rem;
  color: #fff;
  font-weight: 300;
  letter-spacing: 4px;
  font-family: 'roboto-black'; // text-align: left;

  // margin-left: -10px;
}

.mision {
  // max-width: 80%;
  // margin: 15px auto;
  //   display: table;
  margin: 0 auto;
  color: #fff;
  font-weight: 300;
  line-height: 1.5;
  font-size: 0.9rem;
  font-family: 'roboto-regular'; // text-align: left;
  padding: 0px 10%;
  text-align: justify;
  // transform: translate(50%,0%);
  // padding: 25%;
}

@media screen and (max-width: 991px) {
  .mision {
    // max-width: 80%;
    // margin: 20px auto;
    display: table;
    margin: 0 auto;
    color: #fff;
    font-weight: 300;
    line-height: 1.5;
    font-size: 20px;
    padding: 0px 10%;
    text-align: justify;
    // text-align: left;
    // transform: translate(50%,0%);
    // padding: 25%;
  }

  .cuadro {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    min-height: 160px;
    width: 230px;
    margin: 0 auto;
    // float: left;
    margin-right: 40px;
    display: block;
    font-weight: 300;
    padding: 30px;
    font-size: 16px;
    margin-bottom: 10px;
    margin-left: 14px;
    font-size: 18px;
  }

  .cuadro h3 {
    font-weight: 300;
    margin: 0;
    font-size: 22px;
  }

  .cuadro ul {
    list-style: none;
    padding: 0;
    // margin: 0;
  }

  .cuadro ul > li {
    font-size: 18px;
  }

  // .bg-nosotros-descrip {
  //   min-height: 300px;
  // }

  .titulo {
    margin: 0 auto;
    text-align: center;
    position: relative;
    padding-top: 60px;
    font-size: 2.5rem;
    color: #fff;
    font-weight: 300;
    letter-spacing: 4px;
    font-family: 'roboto-black';
    // margin-left: -10px;
  }
}
.vl {
  border-left: 3px solid rgb(255, 255, 255);
  height: 300px;
  position: absolute;
  left: 100%;
  // margin-left: -3px;
  top: 0;
}
</style>

<style>
.misionp1 {
  /* text-align: justify; */
  /* max-width: 600px; */
  /* margin: 0 auto; */
  /* margin-left: -40px; */
}

/* @media screen and (max-width: 768px) {
  .misionp1 {
    text-align: center;
    max-width: 600px;
    margin: 0 auto;
  }
} */
</style>
